import ApplicationController from './application_controller'
import { useCheckAll } from './mixins/useCheckAllSimple'

export default class extends ApplicationController {
  static targets = ['checkbox', 'selectAllBills', 'billsSelectedCounter', 'billsAmount', 'form', 'checkAllCheckbox', 'checkAllCounter', 'checkAllChecker']

  doConnect() {
    useCheckAll(this, 'data-reference-id', this.getBillsAmount())
  }

  selectAllBillsFromIndexToEnd(fromIndex) {
    this.refreshCheckboxesIncluded()
    this.checkAllFromIndexToEnd(fromIndex)
  }

  updateBillsCount(event) {
    this.updateBase(event.detail.value)
  }

  resetAll(event) {
    this.resetUseCheckAll()
    setTimeout(() => { this.checkAll() }, 0)
  }

  get areUnseenBillsSelected() {
    const checkboxStore = this.useCheckAllState.checkboxStore
    return checkboxStore.previousUniqueGeneralState === 'allChecked' || checkboxStore.generalState === 'allChecked'
  }

  updateSelectAllTargetUncheckedIconVisibility() {
    setTimeout(() => {
      const checkboxStore = this.useCheckAllState.checkboxStore
      const makeUnchekedAllIconVisible = checkboxStore.generalState === 'someChecked'
      const selectAllBillCheckboxId = this.checkAllCheckerTarget.id
      const elem = document.getElementsByClassName(`js-checkbox-${selectAllBillCheckboxId}-unchecked-icon`)[0]
      if (elem) {
        if (makeUnchekedAllIconVisible) {
          elem.classList.remove('hidden')
        } else {
          elem.classList.add('hidden')
        }
      }
    }, 0)
  }

  getBillsAmount() {
    return parseInt(this.billsAmountTarget.textContent.replace(/,/g, ''))
  }
}
